/**
 * @generated SignedSource<<0e896ca7aa7dab4472270cc6fedf5220>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MeasurementDataKind = "number" | "percentage" | "text" | "%future added value";
export type MeasurementsSectionMeasurementTemplatesQuery$variables = {};
export type MeasurementsSectionMeasurementTemplatesQueryVariables = MeasurementsSectionMeasurementTemplatesQuery$variables;
export type MeasurementsSectionMeasurementTemplatesQuery$data = {
  readonly measurementTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly dataKind: MeasurementDataKind;
      };
    }>;
  };
};
export type MeasurementsSectionMeasurementTemplatesQueryResponse = MeasurementsSectionMeasurementTemplatesQuery$data;
export type MeasurementsSectionMeasurementTemplatesQuery = {
  variables: MeasurementsSectionMeasurementTemplatesQueryVariables;
  response: MeasurementsSectionMeasurementTemplatesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MeasurementTemplateConnection",
    "kind": "LinkedField",
    "name": "measurementTemplates",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeasurementTemplateEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeasurementTemplate",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dataKind",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeasurementsSectionMeasurementTemplatesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MeasurementsSectionMeasurementTemplatesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "63e02c463f18d400e46be84665c6b082",
    "id": null,
    "metadata": {},
    "name": "MeasurementsSectionMeasurementTemplatesQuery",
    "operationKind": "query",
    "text": "query MeasurementsSectionMeasurementTemplatesQuery {\n  measurementTemplates {\n    edges {\n      node {\n        id\n        name\n        dataKind\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fbbad22e274ba88b7c2c673a87ca58e4";

export default node;
